import styled from "styled-components";

export const ContainerBody = styled.div`
  width: 80%;
  margin: 25px auto;
`;

export const Message = styled.span`
  color: ${props => props.color};
  font-weight: bold;
`;



// WEBPACK FOOTER //
// ./src/components/Commons/Styles.js